import LogOut from "./LogOut";
import logo from "../assets/logo1.png";
import banner from "../assets/WhatsApp-Image-2026-05-03-at-17.16.41.jpeg"
const Navbar = ({
  darkMode,
  setDarkMode,
  userInfo,
  platforms,
  onSelect,
  activePlatforms,
  toggleAll,
}) => {
  return (
    <>
      <div
        className={`navbar ${darkMode ? "dark container" : "light container"}`}
      >

        <div className="navlogo">
          <img src={banner} alt="" />
          <h1>Golden Section</h1>

          <img id="logo" src={logo} alt="" />
        </div>
        <LogOut />
      </div>
    </>
  );
};

export default Navbar;
